export default __webpack_public_path__ + "static/media/partner-rsp.bec3daad.webp";